import React, { Component } from 'react'
import { Label, Row, Col } from 'reactstrap'
import ModalForm from '../../../../comum/components/ModalForm'
import CheckboxField from '../../../../comum/components/CheckboxField'
import FormInputSimples from '../../../../comum/components/FormInputSimples'
import { observer } from 'mobx-react'
import FormDatePicker from '../../../../comum/components/FormDatePicker'
import DadosRetiradaStore from '../stores/DadosRetiradaStore'

@observer
export default class ModalDadosRetirada extends Component {

    constructor(props) {
        super(props);

        this.importController = this.props.controller;

        this.controller = new DadosRetiradaStore();
    }
    
    render() {
        return (
            <ModalForm
                onClickCancelar={this.importController.fecharModalRetirada}
            >
                <h2>
                    Incluir dados de retirada
                </h2>
                <Row>
                    <FormDatePicker xs={12} sm={12} md={6} lg={6} xl={6} onChange={this.controller.setDataRetirada} titulo="Data de retirada" />
                    <Col className="mb-2">
                        <Label>Preferências</Label>
                        <div className="mb-2">
                            <CheckboxField noTitle={true} className="px-0" text="Incluir data de retirada no cálculo do valor de armazenagem" onClick={(event) => this.controller.setPreferencia(event, 'incluirDtRetCalculo')} />
                        </div>
                        <div className="mb-2">
                            <CheckboxField noTitle={true} className="px-0" text="Pagar dia de porta" onClick={(event) => this.controller.setPreferencia(event, 'pagarDiaPorta')} />
                        </div>
                        <div className="mb-2">
                            <CheckboxField noTitle={true} className="px-0" text="Desova house (direto para o caminhão)" onClick={(event) => this.controller.setPreferencia(event, 'desovaHouse')} />
                        </div>
                        <div className="mb-2">
                            <CheckboxField noTitle={true} className="px-0" text="Retirada via barcaça" onClick={(event) => this.controller.setPreferencia(event, 'retiradaBarcaca')} />
                        </div>
                    </Col>
                        <FormInputSimples type="textarea" xs={12} sm={12} md={12} lg={12} xl={12} titulo="Referência cliente" onChange={(event) => this.controller.setReferencia(event.target.value)} />
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/ModalDadosRetirada.js